import "./css/leftContainer.scss";
import PlantDetail from "./plantDetail";
import { Button, Icon, Select } from "@scuf/common";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../common/store/combinedReducer";
import { useEffect, useRef, useState } from "react";
import {
  getAssignedRoles,
  getOrgStatus,
  getUserRoles,
  removeSelectedVM,
  setActivePage,
  setAssignedRoles,
  setAssignedStatus,
  setLoading,
  setOrgDropDown,
  setSelectedPlant,
  setSelectedTenant,
  setSelectedView,
  setSignalR,
  setSiteID,
  setUserRoleStatus,
  setVMData,
  setVmIdNotification,
  settabledata,
} from "../../../store/action";
import _ from "lodash";
import dataManagement from "../../../../common/assets/data-management.svg";
import userManagement from "../../../../common/assets/user-management.svg";
import {
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
} from "@microsoft/signalr";
import config, {
  REQUIRED_PERMISSIONS,
} from "../../../../common/authentication/config";
import AuthProvider from "../../../../common/authentication/authService";
import { INotification } from "../../../store/model";
import { customToast } from "../../../../App";
import SelectDropdown from "../../../../common/utility/Dashboard/selectDropdown";
import {
  closeConnection,
  setUpSignalRConnection,
} from "../../../../common/utility/Dashboard/utility";

const LeftContainer = (props: any) => {
  const dispatch = useDispatch();
  let connection: HubConnection;
  const word = "...";
  const index: any = localStorage.getItem("index") || 0;
  const activePage = useSelector((state: AppState) => {
    return state.reducer.activePage;
  });
  const orgData = useSelector((state: AppState) => {
    return state.reducer.orgData;
  });
  const orgsDropDownData = useSelector((state: AppState) => {
    return state.reducer.orgsDropDownData;
  });
  const selectedPlant = useSelector((state: AppState) => {
    return state.reducer.selectedPlant;
  });
  const orgDataStatus = useSelector((state: AppState) => {
    return state.reducer.orgDataStatus;
  });
  const assignedRolesStatus = useSelector((state: AppState) => {
    return state.reducer.assignedRolesStatus;
  });
  const permissions = useSelector((state: AppState) => {
    return state.reducer.permissions;
  });
  const userRolesStatus = useSelector((state: AppState) => {
    return state.reducer.userRolesStatus;
  });
  const signalRConnection = useSelector((state: AppState) => {
    return state.reducer.signalR;
  });
  const tenantDropDownData = useSelector((state: AppState) => {
    return state.reducer.tenantDropDownData;
  });
  const selectedTenantIndex = useSelector((state: AppState) => {
    return state.reducer.selectedTenantIndex;
  });
  const selectedTenant: any = useSelector((state: AppState) => {
    return state.reducer.selectedTenant;
  });
  const [selectedOrg, setSelectedOrg] = useState(selectedPlant);
  const [dom, setDom] = useState(false);
  const [signalrConnection, setSignalrConnection] =
    useState<HubConnection>(signalRConnection);
  const [showUserManagement, setShowUserManagement] = useState(false);
  const [showDataManagement, setShowDataManagement] = useState(false);
  const [selectedData, setSelectedData] = useState<any>();
  const filteredData: any = useRef("");
  // useEffect(() => {
  //   const storageHandler = () => {
  //     closeConnection(signalRConnection, HubConnectionState, dispatch);
  //     if (orgData && orgData[0]?.name) {
  //       setUpSignalRConnection(
  //         orgData[0]?.name,
  //         dispatch,
  //         setSignalrConnection
  //       );
  //     }
  //   };
  //   window.addEventListener("tokenExpiryUpdated", storageHandler);
  //   return () => {
  //     window.removeEventListener("tokenExpiryUpdated", storageHandler);
  //   };
  // }, [signalRConnection]);

  // const closeConnection = async () => {
  //   if (
  //     signalRConnection &&
  //     signalRConnection.state === HubConnectionState.Connected
  //   ) {
  //     await signalRConnection.stop();
  //     // connection
  //     signalRConnection?.onclose((error: any) => {
  //       // console.error(error);
  //     });
  //   }
  // };
  useEffect(() => {
    setSelectedOrg(selectedPlant);
    const valuePermission: any = _.find(permissions, [
      "resources",
      selectedPlant,
    ]);
    setSelectedData(valuePermission);
    if (valuePermission && valuePermission?.permissions.length > 0) {
      const hasUserManagement =
        REQUIRED_PERMISSIONS.CAN_VIEW_USER_MANAGEMENT.every((p: string) =>
          valuePermission.permissions.includes(p)
        );
      const hasDataManagement =
        REQUIRED_PERMISSIONS.TRANSFER_DATA_OR_FILES_IN_AND_OUT.every(
          (p: string) => valuePermission.permissions.includes(p)
        );
      if (hasUserManagement) setShowUserManagement(true);
      if (hasDataManagement) setShowDataManagement(true);
    }
  }, [orgsDropDownData, orgData]);

  useEffect(() => {
    if (
      signalRConnection === undefined ||
      !signalRConnection ||
      !signalRConnection?.state
    ) {
      dispatch(setSignalR(signalrConnection));
    }
  }, [signalrConnection, signalRConnection]);

  useEffect(() => {
    if (orgDataStatus === 200) {
      dispatch(setVmIdNotification(null));
      orgData &&
        orgData.length > 0 &&
        orgData.forEach((data: any) => {
          if (
            data &&
            data.siteId === selectedOrg &&
            data.siteId !== config.SITE_ID
          ) {
            dispatch(setSiteID(data.siteId as string));
            if (data.IsVCDAlive === false)
              customToast(
                "This site is not available currently, please try after sometime.",
                "critical"
              );
            if (
              (signalRConnection &&
                signalRConnection.state === HubConnectionState.Disconnected) ||
              signalRConnection === undefined ||
              !signalRConnection ||
              !signalRConnection?.state
            ) {
              // connect only if the signalr is disconnected as it'll create more wss calls
              setUpSignalRConnection(data.name, dispatch, setSignalrConnection);
            }
          } else if (selectedOrg == "" && data.siteId !== config.SITE_ID) {
            if (
              (signalRConnection &&
                signalRConnection.state === HubConnectionState.Disconnected) ||
              signalRConnection === undefined ||
              !signalRConnection ||
              !signalRConnection?.state
            ) {
              // connect only if the signalr is disconnected as it'll create more wss calls
              setUpSignalRConnection(
                orgData && orgData[0]?.name,
                dispatch,
                setSignalrConnection
              );
            }
          }
        });
    }
    setDom(!dom);
  }, [orgDataStatus, orgData]);

  const navigateToSelectedPage = (value: any) => {
    const selectedView = {
      selectedView: value,
      plantName: selectedData && selectedData.resourceName,
      activePage,
    };
    if (value === "UserManagement" && selectedPlant !== "") {
      if (userRolesStatus === 0) {
        dispatch(
          getUserRoles({
            authorization: localStorage.getItem("access_token"),
            siteId: selectedPlant,
            tenantId: selectedTenant,
          })
        );
      }
      // if (assignedRolesStatus === 0) {
      dispatch(setAssignedStatus(0));
      dispatch(
        getAssignedRoles({
          authorization: localStorage.getItem("access_token"),
          siteId: selectedPlant,
          tenantId: selectedTenant,
        })
      );
      // }
    }
    dispatch(setSelectedView(selectedView));
  };

  const changeTenantData = (value: any) => {
    closeConnection(signalRConnection, HubConnectionState, dispatch);
    const index =
      tenantDropDownData?.findIndex((data: any) => data?.value === value) ?? 0;
    dispatch(
      setSelectedTenant({
        selectedTenant: value,
        selectedTenantIndex: index,
      })
    );
    localStorage.setItem("index", (0).toString());
    dispatch(setOrgDropDown(value));
    // Run the following after setOrgDropDown is completed
    setTimeout(() => {
      if (
        index > -1 &&
        orgsDropDownData?.length > 0 &&
        orgsDropDownData[0].value !== ""
      ) {
        localStorage.setItem("tenantIndex", index.toString());
        dispatch(getOrgStatus(0));
        // dispatch(setActivePage(0));
        dispatch(setLoading(true));
        dispatch(setVMData([]));
        dispatch(settabledata([]));
        dispatch(setAssignedStatus(0));
        dispatch(setUserRoleStatus(0));
        setShowUserManagement(false);
        setShowDataManagement(false);
        dispatch(setAssignedRoles({ data: [] }));
      }
    }, 0);
  };

  const changeOrgData = (value: any) => {
    closeConnection(signalRConnection, HubConnectionState, dispatch);
    const valuePermission = _.find(permissions, ["resources", value]);
    orgsDropDownData?.forEach((data: any, index: any) => {
      if (data && data?.value === value && valuePermission) {
        localStorage.setItem("index", index);
        dispatch(setVMData([]));
        dispatch(settabledata([]));
        dispatch(setLoading(true));
        dispatch(getOrgStatus(0));
        dispatch(setAssignedStatus(0));
        setSelectedOrg(value);
        dispatch(setSelectedPlant(value));
        dispatch(setActivePage(index));
        dispatch(setSiteID(value));
        orgData?.vmDetails?.forEach((element: any) => {
          element.checked = false;
        });
        dispatch(removeSelectedVM());
        const isHonAcaTenant = orgsDropDownData.find(
          (data: any) => data.value === config.SITE_ID
        );
        const hasUserManagement =
          REQUIRED_PERMISSIONS.CAN_VIEW_USER_MANAGEMENT.every((p: string) =>
            valuePermission.permissions.includes(p)
          );
        const hasDataManagement =
          REQUIRED_PERMISSIONS.TRANSFER_DATA_OR_FILES_IN_AND_OUT.every(
            (p: string) => valuePermission.permissions.includes(p)
          );
        if (hasUserManagement && !isHonAcaTenant) setShowUserManagement(true);
        else setShowUserManagement(false);
        if (hasDataManagement && !isHonAcaTenant) setShowDataManagement(true);
        else setShowDataManagement(false);
      }
    });
  };

  return (
    <div className="container-wrapper">
      <div className="left-header-wrapper">
        {tenantDropDownData?.length > 0 &&
          orgsDropDownData?.length > 0 &&
          orgsDropDownData[index]?.value !== "" &&
          tenantDropDownData[selectedTenantIndex]?.value !== "" ? (
          <>
            <div className="left-header">
              <SelectDropdown
                options={tenantDropDownData}
                value={tenantDropDownData[selectedTenantIndex]?.value}
                defaultValue={tenantDropDownData[selectedTenantIndex]?.value}
                onChange={(val: any) => changeTenantData(val)}
                id="manage-tenant-wrapper"
                className="manage-tenant-wrapper"
                dataTestid="manage-tenant-wrapper-test"
              />
              <SelectDropdown
                options={orgsDropDownData}
                defaultValue={orgsDropDownData[index]?.value}
                value={selectedOrg}
                onChange={(val: any) => changeOrgData(val)}
                disabled={
                  orgsDropDownData.length === 1 &&
                  orgsDropDownData[0].value === config.SITE_ID
                }
                className="manage-plant-wrapper"
                id="manage-plant-wrapper"
                dataTestid="manage-plant-wrapper-test"
              />
            </div>

            <div className="manage-plant">
              {showDataManagement && (
                <Button
                  type="primary"
                  className={"button1-active"}
                  icon={<img className="icon-plant" src={dataManagement} />}
                  content="&nbsp; Data Management"
                  iconPosition="left"
                  size="small"
                  data-testid="data-management-button"
                  onClick={() => navigateToSelectedPage("DataManagement")}
                />
              )}
              {showUserManagement && (
                <Button
                  type="primary"
                  className={"button1-active"}
                  icon={<img className="icon-plant" src={userManagement} />}
                  content="&nbsp; User Management"
                  iconPosition="left"
                  size="small"
                  data-testid="user-management-button"
                  onClick={() => navigateToSelectedPage("UserManagement")}
                />
              )}
              {/* <Button type='primary' className={'button1-active'} icon={<img className='icon-plant' src={userManagement} />} content='&nbsp; User Management' iconPosition='left' size='small' onClick={() => navigateToSelectedPage('UserManagement')} /> */}
            </div>
          </>
        ) : null}
      </div>
      <PlantDetail orgData={orgData[0]} />
    </div>
  );
};
export default LeftContainer;